import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getDate, getMonth, getYear, isAfter, isEqual, parse, set } from 'date-fns';

interface TimeRangeValidatorOptions {
  startTimeName: string;

  endTimeName: string;

  format?: string;
}

export function timeRangeValidator(options: Partial<TimeRangeValidatorOptions>): ValidatorFn {
  const inputConfig: TimeRangeValidatorOptions = {
    startTimeName: 'startTime',
    endTimeName: 'endTime',
    format: 'HH:mm',
    ...options,
  };

  return (group: AbstractControl): ValidationErrors | null => {
    if (!(group instanceof FormGroup)) {
      throw new Error('This method can only be used on a FormGroup.');
    }

    if (!group.value[inputConfig.startTimeName] || !group.value[inputConfig.endTimeName]) {
      return { tsRangeTimeNotSet: { value: group } };
    }

    const defaultDate = new Date();
    const start: string | Date = group.value[inputConfig.startTimeName];
    const end: string | Date = group.value[inputConfig.endTimeName];
    const startTime: Date =
      typeof start === 'string'
        ? parse(start, inputConfig.format as string, defaultDate)
        : set(start, {
            year: getYear(defaultDate),
            month: getMonth(defaultDate),
            date: getDate(defaultDate),
          });
    const endTime: Date =
      typeof end === 'string'
        ? parse(end, inputConfig.format as string, defaultDate)
        : set(end, {
            year: getYear(defaultDate),
            month: getMonth(defaultDate),
            date: getDate(defaultDate),
          });

    if (isAfter(startTime, endTime) || isEqual(startTime, endTime)) {
      return { tsRangeNotInRange: { value: group } };
    }
    return null;
  };
}
